import { http } from "@/shared/lib/api/http";

export type TourState = {
  tourId: string;
  completedAt: string | null;
  skippedAt: string | null;
  restartCount: number;
};

/** All of the current user's tour states (server source of truth). */
export async function fetchTourStates(): Promise<TourState[]> {
  const response = await http.get<{ tours: TourState[] }>("/onboarding/tours");
  return response.data.tours;
}

export async function completeTour(tourId: string): Promise<TourState> {
  const response = await http.post<TourState>(`/onboarding/tours/${encodeURIComponent(tourId)}/complete`);
  return response.data;
}

export async function skipTour(tourId: string): Promise<TourState> {
  const response = await http.post<TourState>(`/onboarding/tours/${encodeURIComponent(tourId)}/skip`);
  return response.data;
}

export async function restartTour(tourId: string): Promise<TourState> {
  const response = await http.post<TourState>(`/onboarding/tours/${encodeURIComponent(tourId)}/restart`);
  return response.data;
}
